import React, { ReactNode } from 'react';
import { useUser } from 'contexts/UserContext';

interface IsNotMemberProps {
  organizationId: string;
  children: ReactNode;
}

export const IsNotMember: React.FC<IsNotMemberProps> = ({ organizationId, children }) => {
  const { user } = useUser();

  if (!user) {
    return null;
  }

  const isMember = user.organizationPermissions.some(member => member.organizationId === organizationId);

  return !isMember ? <>{children}</> : null;
};

export default IsNotMember;

